// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resizable-block[data-v-1294b6db]{position:absolute;background:#888;border:2px dashed hsla(0,0%,100%,.8);box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
